import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { IQaA } from '../../helpers/models';

@Component({
    selector: 'app-questions',
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.scss'],
    standalone: false
})
export class QuestionsComponent implements OnInit {
  private readonly microsoftPartnerLink = 'https://msadvertisingpartnerprogram.powerappsportals.com/partner-directory-profile-full/?partnerProfileID=484785a1-d92e-ef11-840a-0022480a899b';
  private readonly microsoftPromoDetailsLink = 'https://help.ads.microsoft.com/#apex/ads/en/50829/3';
  private readonly googleShareLink = 'https://couponer.app/g?utm_source=referral&utm_medium=share-with-friend&utm_campaign=q-and-a';
  private readonly googleCnShareLink = 'https://couponer.app/g-cn?utm_source=referral&utm_medium=share-with-friend&utm_campaign=q-and-a';
  listItems: Array<any> | undefined;
  listItemsSplit: any | undefined = {
    firstList: [],
    secondList: []
  };
  expandHeight:number = 0;
  @Input() listItemsType: string | undefined;
  @Input() title: string | undefined;
  @Input() isLastStep: boolean = false;
  @Input() listItemsData: any[] | undefined;
  isEn:boolean=false;
  showAllQ:boolean = false;
  selectedAccordinBIndex: number | undefined;
  @Input() selectedAccordinAIndex: number | undefined;
  @Output() changeSelectedTabIndex = new EventEmitter<string>();

  questionsArrays:any = {
    google: [
    { //1
      question:'How can Adcore offer a $500 Google Ads coupon?',
      answerA: "As Adcore is a Google Premier Partner, we are able to offer higher-value coupons for all the accounts that are linked to us. We’d like to use it and help advertisers to benefit more from their Google Ads. Click ",
      linkBetween: 'here',
      link: 'https://www.google.com/partners/agency?id=3987411150',
      answerB: ' to see our certifications. '
    },
    { //2
      id: 'eligibleQ',
      question:'Who is eligible for coupons?',
      listTitle: 'There are several criteria that need to be met for the account to be eligible for coupon:',
      list:[
        'The account has no other promotions applied.',
        'The account is billed to a country where Google Partners promotional offers are offered.',
        'The advertiser is new to Google Ads. A key indicator for Google to determine whether the advertiser is new to Google or not is the landing page url. This process may take up to 35 days.',
        'Account has been created within the last 60 days.'
      ],
      answerA: "A coupon credit of up to $500 (USD or currency equivalent) will be issued to the account upon reaching the required spend value of $500. Read more about Google’s  ",
      linkBetween: 'promotional codes policy',
      link: 'https://support.google.com/adspolicy/answer/1396257?hl=en',
      answerB: ', as terms and conditions may differ between applicants. '
    },
    { //3
      question:'Can I receive multiple coupons?',
      answer: 'Each account is eligible for one coupon only. Therefore, if you have multiple accounts, you can receive a coupon for each account as long as you link them.',
    },
    { //4
      question:'Can I link my MCC instead of a single account?',
      answer: 'Absolutely. As soon as you link a user, all the accounts under it (and future accounts!) will be eligible for coupons.',
    },
    { //5
      question:'What should I do if I receive an error message while trying to link my account?',
      answer: "There are several factors that can cause errors when linking your account. If you encounter an error, please don't hesitate to contact us directly for assistance via chat or email at ",
      link:'support@couponer.app'
    },
    { //6
      question:'Why do Google Ads offer coupons?',
      answer: "Google promo codes are mainly used to encourage new advertisers to try their hands at Google Ads. To see if Google's paid advertising services benefit your business, try them out before spending more money. With our role as a Google Premier Partner, we invite you to start using Google Ads and provide coupons that can help you get started."
    },
    { //7
      question:'Will Google send me an email as part of the process?',
      answer: 'To apply Google promo codes to your accounts, we require access to your Google Ads account. As soon as you finish signing up for Couponer, your account will be automatically linked to our manager account. Google Ads will follow up by sending you an email requesting approval, which you can ignore at your discretion.'
    },
    { //8
      question:'How can I see if a coupon was applied?',
      answerA: "You can check the coupon status on your Google Ads account under Tools and settings → Billing → Promotions. It may take up to 35 days for the coupon to be applied by Google to your account. Read more about Google’s ",
      linkBetween: 'promotional codes policy',
      link: 'https://support.google.com/adspolicy/answer/1396257?hl=en',
      answerB:', as terms and conditions may differ between applicants.'
    },
    { //9
      question:"I successfully linked my account, why can't I see my coupon?",
      answerA: 'Your Google promo code might not appear immediately in your account. Coupon eligibility varies depending on ',
      linkBetween: 'Google’s policy',
      link:'https://support.google.com/adspolicy/answer/1396257?hl=en',
      answerB: 'and may differ between countries.'
    },
    { //10
      question:'How can I be sure Adcore is a Google Premier Partner?',
      answerA: "Adcore is a Premier Google Partner in various geographic locations, including EMEA, APAC, and Australia. To verify Adcore's Google Partner status, you can click this ",
      linkBetween: 'link',
      link: 'https://www.google.com/partners/agency?id=3987411150',
    },
    { //11
      question:'Can I create a new Google Ads account with Couponer?',
      answer: 'Sure! Easily create a Google Ads account and apply for a coupon by clicking "Create new account".',
    },
    { //12
      question:'What safety measures does Couponer implement when creating an account?',
      answer: "Couponer is working to protect its user community by preventing unauthorized access, fraudulent activities, and misuse of the app, ensuring a safer experience for all users.",
    },
    { //13
      question:'What accounts can be linked to Couponer?',
      listTitle: 'To link a single account or MCC to Couponer, the following criteria must be met:',
      list:[
        'Single account’s spend must be at least $1 in the last 30 days.',
        'MCC must have at least one account with spend of at least $1 in the last 30 days.',
        'MCC cannot have more than 200 accounts linked to it.'
      ],
    },
    { //14
      question:'How long does it take to redeem a coupon?',
      answer: "It may take up to 35 days for Google to apply the coupon to your account.",
    },
    { //15
      question:'Does the coupon have an expiration date?',
      answer: 'Google promo codes do not expire once they have been applied. If the $500 spent threshold is not met within 60 days of the account creation, the coupon will no longer be valid.'
    },
    { //16
      question:'Is the coupon valid in different countries?',
      answerA: "There can be differences in the terms and conditions for each promotion based on the country or promotion, so make sure to read Google’s ",
      linkBetween: 'promotional codes policy',
      link: 'https://support.google.com/adspolicy/answer/1396257?hl=en',
      answerB: '.'
    },
    { //17
      question:'What happens if my domain is disapproved?',
      answerA: "You can try to improve your website (use ",
      linkBetween: 'this link ',
      link: 'https://www.adcore.com/blog/optimizing-your-domain-for-success/',
      answerB: ' for help), then make another attempt with the same domain or explore a different domain.'
    },
    { //18
      question:'How will I know if the account was created?',
      answer: 'You will receive an email with the account details.'
    },
    { //19
      question:'How can I unlink my account?',
      answer: 'In order to unlink your account please contact us via chat or email: ',
      link:'support@couponer.app'
    },
    { //20
      question:'Can I share this app with friends?',
      answerA: 'Of course! Just use ',
      linkBetween: 'this link',
      link: this.googleShareLink,
    },
    { //21
      question:'How can I contact the support team?',
      answer: 'You can email us to ',
      link:'support@couponer.app'
    }
    ],
    cnGoogle: [
      { //1
        question:'Adcore怎么提供$500的Google Ads优惠券？',
        answerA: "作为 Google 的首席合作伙伴，Adcore 可以为所有与我们链接的帐户提供更高价值的优惠券。我们希望使用这些优惠券来帮助广告商从 Google Ads 中获得更多的利益。 ",
        linkBetween: '点击此处',
        link: 'https://www.google.com/partners/agency?id=3987411150',
        answerB: '查看我们的认证。'
      },
      { //2
        id: 'eligibleQ',
        question:'谁有资格获得优惠券？',
        listTitle: '要使帐户符合优惠券的资格，需要满足以下几个标准：',
        list:[
          '该帐户没有其他促销活动。',
          '该帐户被计费的国家提供Google合作伙伴促销优惠。',
          '广告主是Google Ads的新用户。Google确定广告主是否为Google新用户的一个关键指标是着陆页URL。这个过程可能需要多达35天。',
          '帐户在过去的60天内创建。'
        ],
        answerA: "当达到所需的$500消费值时，将向该帐户发放高达$500（美元或等值货币）的优惠券信用。请阅读有关Google",
        linkBetween: '促销代码政策',
        link: 'https://support.google.com/adspolicy/answer/1396257?hl=en',
        answerB: ',的更多信息，因为申请人之间的条款和条件可能有所不同。'
      },
      { //3
        question:'我可以收到多个优惠券吗？',
        answer: '每个账户只有一个优惠券资格。因此，如果您有多个账户，只要链接它们，每个账户就可以获得一个优惠券。',
      },
      { //4
        question:'我能否将我的MCC链接而不是单个账户？',
        answer: '完全正确。一旦您链接了一个用户，其下的所有账户（以及未来的账户！）都有资格获得优惠券。',
      },
      { //5
        question:'如果我在尝试链接我的账户时收到错误消息，我该怎么办？',
        answerA: "链接账户时可能会出现几个因素导致错误。如果您遇到错误，请不要犹豫通过聊天或发送电子邮件至",
        linkType:true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: '直接联系我们以获取帮助。'
      },
      { //6
        question:'为什么Google Ads提供优惠券？',
        answer: "Google优惠码主要用于鼓励新广告客户尝试Google Ads。在花费更多资金之前，可以先尝试使用Google的付费广告服务来了解它是否能够为您的业务带来益处。作为Google Premier合作伙伴，我们邀请您开始使用Google Ads，并提供可以帮助您入门的优惠券。"
      },
      { //7
        question:'在此过程中，Google会向我发送电子邮件吗？',
        answer: '要将Google优惠码应用到您的账户中，我们需要访问您的Google Ads账户。一旦您完成Couponer的注册，您的账户将自动链接到我们的管理员账户。Google Ads会随后发送电子邮件给您请求审批，您可以根据自己的意愿选择忽略它。'
      },
      { //8
        question:'我如何查看是否已应用优惠券？',
        answerA: "您可以在Google Ads账户的“工具与设置”→“账单”→“促销”下检查优惠券的状态。Google 最多可能需要 35 天才能将优惠券发放到您的帐户。详细了解 Google 的",
        linkBetween: '折扣码政策',
        link: 'https://support.google.com/adspolicy/answer/1396257?hl=zh-Hans',
        answerB:'，因为条款和条件可能因申请人而异。'
      },
      { //9
        question:"我成功链接了账户，为什么我看不到我的优惠券？",
        answerA: '你的Google优惠码可能不会立即出现在你的账户中。优惠券的资格根据',
        linkBetween: 'Google的政策',
        link:'https://support.google.com/adspolicy/answer/1396257?hl=en',
        answerB: '而异，可能在不同的国家之间有所不同。'
      },
      { //10
        question:'如何确认Adcore是Google Premier合作伙伴？',
        answerA: "Adcore是谷歌的首席合作伙伴（Premier Google Partner），涵盖EMEA，APAC和澳大利亚等多个地理位置。您可以点击此",
        linkBetween: '链接',
        link: 'https://www.google.com/partners/agency?id=3987411150',
        answerB: '查实Adcore的谷歌合作伙伴身份。'
      },
      { //11
        question:'我可以使用 Couponer 创建一个新的 Google Ads 账户吗？',
        answer: '当然！只需点击“创建新账户”轻松创建一个 Google Ads 账户，并申请优惠券。',
      },
      { //12
        question:'Couponer在创建账户时采取了哪些安全措施？',
        answer: "Couponer正在努力保护其用户社区，防止未经授权的访问、欺诈活动和应用程序的滥用，确保所有用户的更安全体验。",
      },
      { //13
        question:'什么样的账户可以链接到Couponer？',
        listTitle: '要将单个账户或MCC链接到Couponer，必须满足以下条件：',
        list:[
          '单个账户在过去的30天内支出至少为$1。',
          'MCC必须至少有一个账户在过去的30天内支出至少为$1。',
          'MCC不能链接超过200个账户。'
        ],
      },
      { //14
        question:'兑换优惠券需要多长时间？',
        answer: "Google可能需要多达35天的时间才能将优惠券应用到您的账户中。",
      },
      { //15
        question:'优惠券有过期日期吗？',
        answer: '一旦应用了Google优惠码，它们就不会过期。如果在账户创建后的60天内未达到500美元的广告支出门槛，则该优惠券将不再有效。'
      },
      { //16
        question:'优惠券在不同的国家有效吗？',
        answerA: "不同国家或促销活动的优惠券使用条款和条件可能会有所不同，因此请务必仔细阅读Google的",
        linkBetween: '促销代码政策',
        link: 'https://support.google.com/adspolicy/answer/1396257?hl=en',
        answerB: '。'
      },
      { //17
        question:'如果我的域名被驳回会发生什么？',
        answerA: "你可以尝试改进你的网站（",
        linkBetween: '使用此链接获取帮助',
        link: 'https://www.adcore.com/blog/optimizing-your-domain-for-success/',
        answerB: '），然后再次尝试使用同一域名或探索其他域名。'
      },
      { //18
        question:'如何确认账户是否已创建？',
        answer: '您将收到一封包含账户详情的电子邮件。'
      },
      { //19
        question:'我如何取消链接我的账户？',
        answerA: '要取消链接您的账户，请通过在线聊天或发送电子邮件至',
        linkType:true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: '与我们联系。'
      },
      { //20
        question:'我可以与朋友分享这个应用吗？',
        answerA: '当然！只需使用此',
        linkBetween: '链接',
        link: this.googleCnShareLink,
      },
      { //21
        question:'如何联系支持团队？',
        answerA: '您可以发送电子邮件至',
        linkType:true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: '与我们联系。'
      }
    ],
    microsoft:[
      { //1
        question:'How can Adcore offer Microsoft Ads coupons?',
        answerA: 'As a Microsoft Advertising Elite Partner, Adcore can provide exclusive promotional offers for accounts linked to our manager account. These offers are designed to help advertisers get started and scale faster on Microsoft Ads. Click ',
        linkBetween: 'here',
        link: this.microsoftPartnerLink,
        answerB: ' to see our certifications.'
      },
      { //2
        question:'What coupons are currently available?',
        listTitle: 'We offer a spend-match bonus for new accounts running Performance Max (PMax) campaigns, as outlined below:',
        list:[
          'Spend $500 → Get $500',
          'Spend $1,000 → Get $1,000',
          'These offers apply specifically to new Microsoft Ads PMax campaigns.'
        ],
      },
      { //3
        id: 'eligibleQ',
        question:'Who is eligible for coupons?',
        listTitle: 'To qualify, accounts must meet the following criteria:',
        list:[
          'Newly created account (within the last 30 days)',
          'No more than one promotional offer per MCC',
          'Minimum spend of $1',
          'Must run Performance Max (PMax) campaigns',
          'Must reach the required spend threshold within 90 days from the time the coupon is applied'
        ],
      },
      { //4
        question:'Can I receive multiple coupons?',
        answer: 'No, only one coupon can be applied per MCC.'
      },
      { //5
        question:'Can I link my MCC instead of a single account?',
        answer: 'Yes, you can link your MCC and apply the coupon to eligible accounts under it.'
      },
      { //6
        question:'What should I do if I receive an error while linking my account?',
        answerA: 'If you encounter any issues, please contact us via chat or email at ',
        linkType: true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: ' and we\'ll assist you.'
      },
      { //7
        question:'Why does Microsoft Ads offer coupons?',
        answer: 'Coupons are designed to help new advertisers test Microsoft Ads with reduced risk and evaluate performance before increasing spend.'
      },
      { //8
        question:'Why did I receive an email from Microsoft Ads?',
        answer: 'To apply the coupon, we request access to your account. After signing up to Couponer, your account is linked to our manager account, and Microsoft may send an approval email.'
      },
      { //9
        question:'How can I check if a coupon was applied?',
        answer: 'Go to: Billing and Payments, then Payment methods, then Promotional offers.<br>Please allow up to 7 days for the coupon to appear.'
      },
      { //10
        question:'I linked my account but don\'t see the coupon. Why?',
        listTitle: 'Possible reasons include:',
        list: [
          'The spend requirement has not yet been met',
          'You are still within the 90-day window',
          'The coupon is still being processed',
          'Eligibility requirements were not met',
          'Regional limitations may apply'
        ]
      },
      { //11
        question:'How can I verify Adcore is a Microsoft Elite Partner?',
        answerA: 'Adcore holds Microsoft Ads Elite Partner status across multiple regions including EMEA, APAC, and Australia. Click ',
        linkBetween: 'here',
        link: this.microsoftPartnerLink,
        answerB: ' to verify.'
      },
      { //12
        question:'Can I create a new Microsoft Advertising account with Couponer?',
        answer: 'Yes. You can create a new account directly through Couponer and apply for a coupon.'
      },
      { //13
        question:'What safety measures does Couponer implement?',
        answer: 'Couponer helps protect users by preventing unauthorized access, fraud, and misuse of accounts.'
      },
      { //14
        question:'What accounts can be linked to Couponer?',
        list:[
          'Single accounts must have at least $1 spend in the last 30 days',
          'MCC must include at least one active account with $1 spend',
          'MCC must not exceed 200 linked accounts'
        ],
      },
      { //15
        question:'How long does it take to receive the coupon?',
        answer: 'Up to 7 days after meeting the required spend requirement.'
      },
      { //16
        question:'Does the coupon expire?',
        answer: 'Yes. From the moment the coupon is applied, advertisers have 90 days to reach the spend threshold and use the credited amount.'
      },
      { //17
        question:'Is the coupon valid worldwide?',
        answerA: 'Terms may vary by country. Please review the ',
        linkBetween: 'applicable promotional details',
        link: this.microsoftPromoDetailsLink,
        answerB: '.'
      },
      { //18
        question:'What happens if my domain is disapproved?',
        answer: 'You can update your website and reapply, or try a different domain.'
      },
      { //19
        question:'How will I know if my account was created?',
        answer: 'You will receive an email with the account details.'
      },
      { //20
        question:'How can I unlink my account?',
        answerA: 'Please contact support via chat or email at ',
        linkType: true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: '.'
      },
      { //21
        question:'Can I share Couponer with others?',
        answer: 'Yes, you can share the app using your referral link.'
      },
      { //22
        question:'How can I contact the support team?',
        answerA: 'Email: ',
        linkType: true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app'
      }
    ],
    cnMicrosoft:[
      { //1
        question:'Adcore如何提供Microsoft Ads优惠券？',
        answerA: '作为Microsoft Advertising精英合作伙伴，Adcore能够为与我们管理账户关联的账户提供独家促销优惠。这些优惠旨在帮助广告主更快地在Microsoft Ads上起步和发展。',
        linkBetween: '点击这里',
        link: this.microsoftPartnerLink,
        answerB: '查看我们的认证证书。'
      },
      { //2
        question:'目前有哪些优惠券可用？',
        listTitle: '我们为运行效果最大化广告系列（PMax）的新账户提供消费匹配奖励，具体如下：',
        list:[
          '消费$500 → 获得$500',
          '消费$1,000 → 获得$1,000',
          '这些优惠仅适用于新的Microsoft Ads PMax广告系列。'
        ],
      },
      { //3
        id: 'eligibleQ',
        question:'谁有资格获得优惠券？',
        listTitle: '要获得资格，账户必须满足以下条件：',
        list:[
          '新创建的账户（30天内）',
          '每个MCC仅限一次促销优惠',
          '最低消费$1',
          '必须运行效果最大化广告系列（PMax）',
          '必须在优惠券应用后90天内达到所需消费门槛'
        ],
      },
      { //4
        question:'我可以获得多个优惠券吗？',
        answer: '不可以，每个MCC仅可使用一个优惠券。'
      },
      { //5
        question:'我可以关联我的MCC而不是单个账户吗？',
        answer: '可以，您可以关联您的MCC，并将优惠券应用于其下的符合条件的账户。'
      },
      { //6
        question:'如果在关联账户时收到错误提示，我该怎么办？',
        answerA: '如果遇到任何问题，请通过聊天或发送电子邮件至',
        linkType:true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: '联系我们，我们将为您提供帮助。'
      },
      { //7
        question:'Microsoft Ads为什么提供优惠券？',
        answer: '优惠券旨在帮助新广告主以较低风险测试Microsoft Ads，并在增加投入前评估广告效果。'
      },
      { //8
        question:'为什么我收到了Microsoft Ads的电子邮件？',
        answer: '为了应用优惠券，我们需要访问您的账户。在您注册Couponer后，您的账户将关联到我们的管理账户，Microsoft可能会发送一封审批邮件。'
      },
      { //9
        question:'如何查看优惠券是否已应用？',
        answer: '请前往：账单与付款 → 付款方式 → 促销优惠。<br>优惠券可能需要最多7天才能显示。'
      },
      { //10
        question:'我已关联账户，但看不到优惠券，为什么？',
        listTitle: '可能的原因包括：',
        list: [
          '尚未达到消费要求',
          '仍在90天窗口期内',
          '优惠券仍在处理中',
          '未满足资格要求',
          '可能存在地区限制'
        ]
      },
      { //11
        question:'如何验证Adcore是Microsoft精英合作伙伴？',
        answerA: 'Adcore在EMEA、APAC和澳大利亚等多个地区拥有Microsoft Ads精英合作伙伴资质。',
        linkBetween: '点击这里',
        link: this.microsoftPartnerLink,
        answerB: '验证。'
      },
      { //12
        question:'我可以通过Couponer创建新的Microsoft Advertising账户吗？',
        answer: '可以。您可以直接通过Couponer创建新账户并申请优惠券。'
      },
      { //13
        question:'Couponer实施了哪些安全措施？',
        answer: 'Couponer通过防止未经授权的访问、欺诈行为和账户滥用来保护用户。'
      },
      { //14
        question:'哪些账户可以关联到Couponer？',
        list:[
          '单个账户在过去30天内消费至少$1',
          'MCC必须包含至少一个消费$1的活跃账户',
          'MCC关联账户不得超过200个'
        ],
      },
      { //15
        question:'获得优惠券需要多长时间？',
        answer: '在达到所需消费要求后，最多7天。'
      },
      { //16
        question:'优惠券会过期吗？',
        answer: '会。从优惠券应用之日起，广告主有90天时间达到消费门槛并使用赠送金额。'
      },
      { //17
        question:'优惠券在全球范围内有效吗？',
        answerA: '条款可能因国家而异。请查看',
        linkBetween: '适用的促销详情',
        link: this.microsoftPromoDetailsLink,
        answerB: '。'
      },
      { //18
        question:'如果我的域名被拒绝会怎样？',
        answer: '您可以改进网站后重新申请，或尝试使用其他域名。'
      },
      { //19
        question:'如何知道账户是否已创建？',
        answer: '您将收到一封包含账户详情的电子邮件。'
      },
      { //20
        question:'如何取消关联我的账户？',
        answerA: '请通过聊天或发送电子邮件至',
        linkType:true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: '联系客服。'
      },
      { //21
        question:'我可以将Couponer分享给其他人吗？',
        answer: '可以，您可以使用您的推荐链接分享该应用。'
      },
      { //22
        question:'如何联系客服团队？',
        answerA: '电子邮件：',
        linkType:true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app'
      }
    ],
    tiktok: [
      { //1
        question:'How can Adcore offer TikTok Ads credits?',
        answer: 'As an official TikTok Ads partner through the Channel Sales Partner Program, Adcore can provide exclusive incentives for new advertisers. These rewards are designed to help businesses get started on TikTok Ads and scale faster by matching their initial ad spend.'
      },
      { //2
        question:'What is the TikTok Ads incentive offer?',
        listTitle: 'TikTok provides a 1:1 matching credit based on your ad spend. The more you invest, the more you get back:',
        list: [
          'Spend $250 → Get $250 credit',
          'Spend $500 → Get $500 credit',
          'Spend $1,000 → Get $1,000 credit',
          'Spend $4,000 → Get $4,000 credit',
          'Spend $6,000 → Get $6,000 credit',
          'Spend $10,000 → Get $10,000 credit',
          'This means your advertising budget can effectively double during the promotion period.'
        ]
      },
      { //3
        id: 'eligibleQ',
        question:'Who is eligible for TikTok Ads credits?',
        listTitle: 'To qualify for the incentive program, advertisers must meet the following criteria:',
        list: [
          'New TikTok Ads advertisers: no existing TikTok Ads account associated with the same domain in the past 6 months, or a new account created within the last 90 days.',
          'Register through an approved partner like Adcore',
          'Use TikTok Ads Manager',
          'Meet the minimum spend requirement within the promotion window',
          'Eligibility may vary by region and campaign setup.'
        ]
      },
      { //4
        question:'What is the promotion window?',
        listTitle: 'The promotion window works as follows:',
        list: [
          'Advertisers have 30 days from registration to reach the required spend threshold',
          'This 30-day period is considered the official promotion window',
          'Please note that the 30-day window cannot be extended or rolled over, so plan your campaign spend accordingly'
        ]
      },
      { //5
        question:'When will I receive my TikTok Ads credit?',
        listTitle: 'Credit timing depends on the spend tier:',
        list: [
          'For spend tiers below $10,000: credits are issued on the 31st day after registration (one day after the promotion window ends)',
          'For the $10,000 tier: credits are issued one day after the spend threshold is met',
          'Credits are not applied instantly — please allow 2-3 business days for processing after the conditions are met.'
        ]
      },
      { //6
        question:'How long are the credits valid?',
        listTitle: 'Credits expire by the end of the next quarter following your registration date. Here is a quick reference:',
        list: [
          'Register Jan-Mar → Credits expire end of June',
          'Register Apr-Jun → Credits expire end of September',
          'Register Jul-Sep → Credits expire end of December',
          'Register Oct-Dec → Credits expire end of March (next year)',
          'Make sure to use your credits before they expire to get the full benefit.'
        ]
      },
      { //7
        question:'What spend counts toward the reward?',
        answer: 'Only cash (out-of-pocket) spend qualifies toward the required threshold. Credits, discounts, or previous promotions do not count toward the accumulation.'
      },
      { //8
        question:'Can I receive multiple TikTok Ads credits?',
        answer: 'Each new advertiser or business is eligible for one promotion. Duplicate accounts or repeated attempts are not eligible for additional rewards.'
      },
      { //9
        question:'Can I use an MCC or Business Center account?',
        answer: 'Yes! Advertisers can participate through TikTok Ads Manager accounts managed under a Business Center, provided they meet the eligibility requirements.'
      },
      { //10
        question:'Why does TikTok offer these incentives?',
        answer: 'TikTok offers these incentives to help new advertisers experience the platform with lower risk. It is a great opportunity to test creatives, explore audiences, and scale faster with matched spend — all while getting real performance data for your business.'
      },
      { //11
        question:'How do I know if my credit was applied?',
        answer: 'Credits will appear directly inside your TikTok Ads Manager billing section once issued. Processing may take a couple of business days after meeting the spend requirement.'
      },
      { //12
        question:'Why don\'t I see my credit yet?',
        listTitle: 'There could be a few reasons:',
        list: [
          'You have not yet reached the required spend threshold',
          'You are still within the 30-day promotion window (credits are issued after it ends)',
          'Credit processing is still underway — please allow 2-3 business days',
          'Eligibility criteria were not fully met',
          'If you believe everything is in order and still do not see your credit, reach out to us and we will help sort it out.'
        ]
      },
      { //13
        question:'What accounts can be linked to Couponer?',
        listTitle: 'To participate:',
        list: [
          'Account must be newly registered',
          'Must meet minimum spend requirements',
          'Must comply with TikTok Ads policies',
          'Must be created via or linked through an approved partner'
        ]
      },
      { //14
        question:'Where do the ad credits apply?',
        answer: 'Ad credits apply only to campaigns run in TikTok Ads Manager. Campaigns or spend outside of TikTok Ads Manager are not eligible for credit matching.'
      },
      { //15
        question:'What happens if my account violates policies?',
        answer: 'TikTok reserves the right to pause, deny, or revoke credits for any policy violations. Compliance with TikTok advertising policies is required at all times to remain eligible.'
      },
      { //16
        question:'Can I create a new TikTok Ads account through Couponer?',
        answer: 'Yes! You can create a new TikTok Ads account through Couponer and apply for the incentive program during onboarding. It only takes a few minutes to get started.'
      },
      { //17
        question:'How can I contact support?',
        answerA: 'For any questions about linking, eligibility, or credits, we are happy to help: ',
        linkType: true,
        link: 'support@couponer.app',
        linkBetween: 'support@couponer.app',
        answerB: ' or use the in-app chat.'
      }
    ]
  }

  constructor() {
  }

  private populateSplitLists(items: any[] = []): void {
    this.listItemsSplit.firstList = [];
    this.listItemsSplit.secondList = [];

    items.forEach((item: any, index: number) => {
      if (index < 10) {
        this.listItemsSplit.firstList.push(item);
      } else {
        this.listItemsSplit.secondList.push(item);
      }
    });

    if (this.listItemsSplit && this.listItemsSplit.secondList) {
      this.expandHeight = this.listItemsSplit.secondList.length * 57;
    }
  }

  ngOnInit(): void {
    if (this.listItemsData) {
      this.populateSplitLists(this.listItemsData);
    }
    if (this.listItemsType)
    {
      this.listItems = this.questionsArrays[this.listItemsType];
      if (this.listItemsType === 'google' || this.listItemsType === 'microsoft' || this.listItemsType === 'tiktok') {
        this.isEn = true;
      }
      if (this.listItems && this.isLastStep){
        /*
        if (this.listItemsType === 'google') {
          let addQ:any={
            question:"Why can't I see my coupon?",
            answerA: 'Your coupon may not appear immediately in your account. Coupon eligibility varies depending on and may differ between countries.',
            linkBetween: 'Google’s policy',
            link:'https://support.google.com/adspolicy/answer/1396257?hl=en',
            answerB: 'and may differ between countries.',
          };

          this.listItems.unshift(addQ);
        }
        if (this.listItemsType === 'cnGoogle') {
          let addQ:any={
            question:"为何无法看到换领的优惠券？",
            answerA: '您的优惠券可能不会立即出现在您的帐户中。优惠券的使用资格因 ',
            linkBetween: 'Google 政策',
            link:'https://support.google.com/adspolicy/answer/1396257?hl=zh-Hans',
            answerB: '而异，并且可能因国家/地区而异。',
          };

          this.listItems.unshift(addQ);
        }
        */
       /*
        if (this.listItemsType === 'microsoft') {
          let addQ:any={
            question:"Why can't I see my coupon?",
            answer: 'Your Microsoft Ads promotional offer might not appear immediately in your account. Coupon eligibility varies depending on Microsoft’s policy and may differ between countries.'
          };

          this.listItems.unshift(addQ);
        }
        if (this.listItemsType === 'cnMicrosoft') {
          let addQ:any={
            question:"为什么我看不到我的优惠券？",
            answer: '您的 Microsoft 广告促销优惠可能不会立即出现在您的账户中。优惠券的资格取决于 Microsoft 的政策，并且在不同的国家可能会有所不同。'
          };

          this.listItems.unshift(addQ);
        } */
      }
      this.populateSplitLists(this.listItems);
    }
    else this.listItems = [];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.selectedAccordinAIndex === 1) {
      this.selectedAccordinBIndex = -2;
    }
  }

  handleAccordinAChange(e:any) {
    if (e) {
      this.selectedAccordinAIndex = e.index;
      this.selectedAccordinBIndex = -2;
      this.changeSelectedTabIndex.emit(e);
    }
  }

  handleAccordinBChange(e:any) {
    if (e) {
      this.selectedAccordinBIndex = e.index;
      this.selectedAccordinAIndex = -2;
      e.index = -2;
      this.changeSelectedTabIndex.emit(e);
    }
  }
}
